import { trim } from "lodash";
import { IntlShape } from "react-intl";

export const getNamePossessive = (name: string): string =>
  `${name}${name.endsWith("s") ? "'" : "'s"}`;

export function formatSlug(s: string): string {
  let slug = s.toLowerCase();
  slug = slug.normalize("NFD").replace(/\p{Diacritic}/gu, "");
  slug = slug.replace(/[^a-z0-9]+/g, "-");
  slug = trim(slug, "-");
  return slug;
}

export const formatOrganizationMembershipKind = (
  intl: IntlShape,
  kind: "ADMIN" | "EDITOR" | "OWNER" | "READER",
) => {
  return {
    OWNER: intl.formatMessage({ defaultMessage: "Owner" }),
    ADMIN: intl.formatMessage({ defaultMessage: "Member" }),
    EDITOR: intl.formatMessage({ defaultMessage: "Member" }),
    READER: intl.formatMessage({ defaultMessage: "Member" }),
  }[kind];
};

export const formatCompetitionMembershipKind = (
  intl: IntlShape,
  kind: "HOST" | "PARTICIPANT",
) => {
  return {
    HOST: intl.formatMessage({ defaultMessage: "Host" }),
    PARTICIPANT: intl.formatMessage({ defaultMessage: "Participant" }),
  }[kind];
};
export const formatVisibilityKind = (
  intl: IntlShape,
  kind: "AUTHENTICATED" | "MEMBERS" | "UNAUTHENTICATED",
) => {
  return {
    AUTHENTICATED: intl.formatMessage({ defaultMessage: "Private" }),
    MEMBERS: intl.formatMessage({ defaultMessage: "Invited" }),
    UNAUTHENTICATED: intl.formatMessage({ defaultMessage: "Public" }),
  }[kind];
};
